var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

export {
  __name
};
//# sourceMappingURL=chunk-G5GHKT7C.mjs.map
